import React from 'react'

const Sceniro = () => {
  return (
    <div>Sceniro</div>
  )
}

export default Sceniro